import { FileText, Paperclip, Settings, Wrench } from "lucide-react";
import type { ParserKey } from "@noa/api-core";

export type MaximoDocType = "asset" | "workorder" | "jobplan" | "doclink";

export type PresetColor = "blue" | "orange" | "green" | "purple";

export interface SyncPreset {
  key: MaximoDocType;
  icon: React.ReactNode;
  schemaId: string;
  color: PresetColor;
  defaultVision?: boolean;
}

/** Static Tailwind classes for icon colors — dynamic interpolation doesn't work */
export const ICON_COLOR_CLASSES: Record<PresetColor, string> = {
  blue: "text-blue-500",
  orange: "text-orange-500",
  green: "text-green-500",
  purple: "text-purple-500",
};

export const SYNC_PRESETS: SyncPreset[] = [
  { key: "asset", icon: <Settings size={14} />, schemaId: "maximo_asset", color: "blue" },
  { key: "workorder", icon: <Wrench size={14} />, schemaId: "maximo_workorder", color: "orange" },
  { key: "jobplan", icon: <FileText size={14} />, schemaId: "maximo_jobplan", color: "green" },
  { key: "doclink", icon: <Paperclip size={14} />, schemaId: "maximo_doclink", color: "purple", defaultVision: true },
];

export const PARSER_OPTIONS: { value: ParserKey; label: string }[] = [
  { value: "PDF", label: "PDF (Docling)" },
  { value: "PDF_FAST", label: "PDF Fast" },
  { value: "DOCX", label: "DOCX" },
  { value: "HTML", label: "HTML" },
  { value: "TXT", label: "Text" },
  { value: "MARKDOWN", label: "Markdown" },
];
